import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { AppContext } from '@lightspeed-invoicing/core-client/frontend'
import './header.scss'
import Breadcrumbs from './breadcrumbs.component.jsx'
import Icon from "../icon/icon.component.jsx"
import OnBoardingTitle from "./onboardingtitle.component.jsx"
import { FormattedMessage, injectIntl } from "react-intl"
import $ from 'jquery'
import BulkFeedbackComponent from "../../bulk/BulkFeedbackComponent.tsx"

import AccountStatusBadgeComponent from "./components/AccountStatusBadgeComponent"
import EnvironmentBannerComponent from "./components/EnvironmentBannerComponent"

class Header extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {}

        this.onToggleMenu = this.props.onToggleMenu || function () {
        }
        this.toggleMenu = this.toggleMenu.bind(this)
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        $('[data-toggle="tooltip"]').tooltip()
    }

    componentDidMount() {
        $('[data-toggle="tooltip"]').tooltip()
    }

    toggleMenu(event) {
        event?.preventDefault()
        this.onToggleMenu()
    }

    render() {
        const user = AppContext.getUserLoggedIn()

        const name = user.attributes.firstName + ' ' + user.attributes.lastName.charAt(0).toUpperCase() + '.'
        const letters = user.attributes.firstName.charAt(0).toUpperCase() + user.attributes.lastName.charAt(0).toUpperCase()
        const userInfo = <span>
            <Icon value={"user-circle"}/>
            <span className="d-none d-xl-inline-block text-truncate" style={{maxWidth: '100px'}}>
                {name}
            </span>
            <span className="d-xl-none">
                {letters}
            </span>
        </span>

        const isOnBoarding = AppContext.getAccount().attributes.onBoardingStatus === "pending"
        const onBoardingStartUpGuideInProgress = AppContext.getAccount().attributes.onBoardingStartUpGuideInProgress

        return (
            <div>
                <EnvironmentBannerComponent/>

                <div className="bg-white border-bottom box-shadow fixed-top">
                    <div className="d-flex justify-content-between justify-content-md-start">
                        <h5 onClick={this.toggleMenu} className="align-self-center logo ml-3 d-xl-none">
                            <Icon className={"mt-2"} size={"1.1rem"} value={"bars"}></Icon>
                        </h5>

                        <div className={`box-shadow py-2 px-3 logo-sidebar ${!isOnBoarding && 'bg-header-img'}`}>
                            <h5 className="logo font-weight-normal text-align-center my-0">
                                <Link class="d-none d-xl-flex" to={'/'}><img src='/images/QuoteM_icon_flat.png' height='32px' /></Link>
                                <Link class="d-xl-none bg-white" to={'/'}><img src="/images/QuoteM_horizontal_flat_cropped.png" height="35px"/></Link>
                            </h5>
                        </div>

                        <div className={"border-left align-self-center d-none d-md-flex pl-4"}>
                            {!isOnBoarding ? <Breadcrumbs /> : <OnBoardingTitle />}
                        </div>

                        <div className="align-self-center d-none d-md-block ml-auto">
                            <AccountStatusBadgeComponent/>
                        </div>

                        {onBoardingStartUpGuideInProgress &&
                            <div className="d-none d-md-flex ml-auto">
                                <div className={"align-self-center"}>
                                    <Link to={'/congrats'}
                                          className="btn btn-sm btn-info mb-0 text-align-center rounded py-1">
                                        <FormattedMessage
                                            id="main.menu.status.start_up_guide"
                                            defaultMessage="Start up guide"
                                        />
                                    </Link>
                                </div>
                            </div>
                        }

                        <nav className="align-self-center mr-3 ml-md-auto">
                            <div className="d-none d-md-flex ">
                                <div className="pr-2 user-logged-in">
                                    <BulkFeedbackComponent/>
                                </div>
                                <div className="text-dark user-logged-in">
                                    {isOnBoarding ? userInfo :
                                        <Link to={'/users/edit/' + AppContext.getUserLoggedIn().id}> {userInfo}</Link>}
                                    <span className={"ml-1"}>
                                        <a href={
                                            AppContext.getOptions().apiUrl + "/logout?r=" +
                                            AppContext.getOptions().webCpqUrl + "/logout"
                                        }>
                                            <Icon value="sign-out-alt"/>
                                        </a>
                                    </span>
                                </div>
                            </div>
                        </nav>
                    </div>

                </div>
            </div>
        )
    }
}

export default injectIntl(Header)


// WEBPACK FOOTER //
// ./src/common/layout/header.component.jsx